import { render, staticRenderFns } from "./ConfirmationStage.vue?vue&type=template&id=4e7b847a&scoped=true&"
import script from "./ConfirmationStage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationStage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationStage.vue?vue&type=style&index=0&id=4e7b847a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7b847a",
  null
  
)

export default component.exports